"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _session = require("../../context/session");

const PrivateRoute = ({
  component: Component,
  location,
  isBeta,
  ...rest
}) => {
  const {
    status
  } = (0, _session.useSession)({
    required: true
  });
  if (status !== _session.SessionStatus.Authenticated) return null;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, (0, _extends2.default)({}, rest, {
    render: props => {
      const showBeta = isBeta ? Boolean(process.env.BETA) : true;
      if (!showBeta) return /*#__PURE__*/_react.default.createElement(NotFound, null);
      return /*#__PURE__*/_react.default.createElement(Component, props);
    }
  }));
};

var _default = PrivateRoute;
exports.default = _default;
module.exports = exports.default;